import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import appConfig from 'src/authConfig';
import { toast } from 'react-toastify';

const Error = ({ error }) => {
  const { instance, accounts } = useMsal();
  const account = accounts[0] || {};

  const handleLogout = () => {
    const accountHomeId = account?.homeAccountId;
    if (accountHomeId) {
      const logoutRequest = {
        account: instance.getAccountByHomeId(accountHomeId),
        postLogoutRedirectUri: appConfig.authRedirectUrl,
      };
      sessionStorage.removeItem("polaris-user-profile");
      instance.logoutRedirect(logoutRequest);
    } else {
      toast.error("No valid AccountId found for the account.");
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      textAlign="center"
      justifyContent="center"
    >
      <Container maxWidth="md">
        <Typography align="center" variant="h1" mb={4}>
          Oops!
        </Typography>
        <Typography align="center" variant="h4" mb={4}>
          {error?.message ? error?.message : "This page you are looking for could not be found."}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            color="primary"
            variant="contained"
            
            onClick={handleLogout}
            disableElevation
          >
            Try Again
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default Error;